import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { IConfigStore } from './config.store';
import { Membership, UserStore } from './user.types';

const config: Partial<IConfigStore> = (process.env.CONFIG as Partial<IConfigStore>) || {};

const initialState = {
  userId: 0,
  isCredentialValid: true,
  credentials: {
    apiKey: '',
    hash: '',
    token: '',
  },
  membership: {} as Membership,
  details: {
    firstName: '',
    email: '',
  },
  isLoading: false,
  userToken: '',
  auth: config.auth ?? 'Bearer',
};

export interface IUserStore extends UserStore {
  setUser: (user: Omit<UserStore, 'ai' | 'membership'>) => void;
  setIsCredentialValid: (isCredentialValid: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  setUserToken: (token: string) => void;
  setMembership: (membership: UserStore['membership']) => void;
}

export const useUserStore = create<IUserStore>()(
  devtools(
    immer((set, _get) => ({
      ...initialState,
      setUser: (user) => set({ ...user }),
      setIsLoading: (isLoading) => set((state) => ({ ...state, isLoading })),
      setIsCredentialValid: (isCredentialValid) =>
        set((state) => ({ ...state, isCredentialValid })),
      setUserToken: (userToken) =>
        set((state) => {
          state.userToken = userToken;
        }),
      setMembership: (membership) => {
        return set((state) => ({ ...state, membership }));
      },
    })),
    { name: 'Viewer | User' }
  )
);
